import { IEirSalesSaveAscertainPayload } from "@modules/eirSalesFacade/interfaces/payloads/IEirSalesSaveAscertainPayload";
import { getAcquisitionType } from "@utils/acquisitionTypeUtils";

export const mapEirSalesSaveAscertainPayload = (
    hasActiveBroadband: boolean,
    broadbandAccountNumber?: string
): IEirSalesSaveAscertainPayload => ({
    activeBroadband: hasActiveBroadband,
    acquisitionType: getAcquisitionType(),
    broadbandAccountNumber,
});
